<div class="copy-user">
  <form [formGroup]="userFormGroup" autocomplete="no-autofill">
    <div class="title-actions">
      <mat-icon class="dialog__close" aria-hidden="false" aria-label="Close icon" (click)="closeDialog()"
        >close</mat-icon
      >
    </div>
    <mat-label class="copy-user__label">{{ 'admin.emailAddress' | xTranslate | titlecase }}</mat-label>
    <mat-form-field appearance="outline">
      <input
        matInput
        placeholder="{{ 'admin.emailAddress' | xTranslate | titlecase }}"
        type="email"
        formControlName="email"
        autocomplete="no-autofill"
        required
      />
    </mat-form-field>
    <div class="copy-user__checkbox">
      <mat-checkbox class="roleClass" formControlName="rolePermissions" l10nTranslate> admin.copyRole </mat-checkbox>
      <mat-checkbox formControlName="profileSettings" l10nTranslate> admin.copyProfile </mat-checkbox>
    </div>
    <button
      mat-flat-button
      color="primary"
      class="copy-user__applybtn"
      [disabled]="userFormGroup.invalid"
      (click)="copyUser()"
      l10nTranslate
    >
      admin.apply
    </button>
  </form>
</div>
